const initialState = {}

const appendedList = (banners, data) => {
  return [data, ...banners ]
}

const updatedList = (banners, data) => {
  const index = banners.findIndex(banner => banner.id == data.id)
  if (index == -1) return banners

  return [
    ...banners.slice(0, index), 
    data,
    ...banners.slice(index + 1, banners.length)
  ]
}

const releasedList = (banners, data) => {
  const index = banners.findIndex(banner => banner.id == data.id)
  if (index == -1) return banners

  return [
    ...banners.slice(0, index), 
    ...banners.slice(index + 1, banners.length)
  ]
}

const banners = (state = initialState, {type, payload}) => {
  switch (type) {
    case 'BANNERS.INIT':
      return {...state, ...payload}
    case 'BANNERS.CREATE':
      return {...state, banners: appendedList(state.banners, payload)}
    case 'BANNERS.UPDATE':
      return {...state, banners: updatedList(state.banners, payload)}
    case 'BANNERS.DELETE':
      return {...state, banners: releasedList(state.banners, payload)}
    default:
      return state
  }
}

export default banners
